import React, { useEffect, useState, useRef } from "react";
import "./ChatAI.css";
import { useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import axios from "axios";
import { toast } from "react-toastify";
import IconsBot from "./Icon.png";

export default function ChatAI() {
  const [textValue, setInputValue] = useState("");
  const [displayMessage, setDisplayMessage] = useState([]);
  const chatContainerRef = useRef(null);
  const [userIcon, setUserIcon] = useState(localStorage.getItem("image"));
  const [arrayOfSuggestedQuestions, setArrayOfSuggestedQuestions] = useState([
    "If you could live in the world of any game, which one would it be and why?",
    "What is the best video game you’ve ever played, and what made it so memorable?",
    "What’s your go-to strategy when facing a tough boss fight or challenging level?",
  ]);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const getInputValue = (e) => {
    setInputValue(e.target.value);
  };
  
  const sendPrompt = async (inputValue) => {
    setInputValue("");
    setLoading(true);
    if (inputValue.trim() === null || inputValue.trim() === "") {
      setLoading(false);
      toast.error("Please enter a prompt");
      return;
    }
    const currentTime = new Date().toLocaleTimeString();
    setDisplayMessage((displayMessage) => [
      ...displayMessage,
      { message: inputValue, sender: "user", time: currentTime },
    ]);
    const request = {
      question: inputValue,
      portal: "games",
    };

    try {
      await axios
        .post("https://gaming-companion.ntgarage.com/api/chat/ask", request)
        .then((res) => {
          const currentTime2 = new Date().toLocaleTimeString();
          setDisplayMessage((displayMessage) => [
            ...displayMessage,
            {
              message: res.data.response,
              sender: "ai",
              time: currentTime2,
            },
          ]);
        });
    } catch (error) {
      console.log(error);
      const currentTime2 = new Date().toLocaleTimeString();
      setDisplayMessage((displayMessage) => [
        ...displayMessage,
        {
          message: error.message,
          sender: "ai",
          time: currentTime2,
        },
      ]);
    } finally {
      setLoading(false);
    }

    setInputValue("");
  };
  //
  useEffect(() => {
    setUserIcon(
      localStorage.getItem("image") ||
        "https://cdn-icons-png.flaticon.com/512/17655/17655721.png"
    );
  }, []);
  //
  useEffect(() => {

    if(localStorage.getItem("no-msisdn") === null){
      localStorage.removeItem("jwt_t");
      navigate('/home');
    }

    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [displayMessage]);

  useEffect(() => {}, []);
  return (
    <div className="container_my">
      <div className="topBar">
        <img
          src="https://cdn-icons-png.flaticon.com/512/8213/8213392.png"
          alt=""
          width={25}
          height={25}
          style={{ margin: "3px 10px" }}
          className="back"
          onClick={() => {
            // if (window.history.length > 1) {
            //   navigate(-1);
            // } else {
              navigate('/home'); 
            // }
          }}
        />
        <span
          style={{
            backgroundColor: "white",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={IconsBot}
            width={40}
            height={40}
            style={{ margin: "3px 10px" }}
            className="aiTop"
          />
        </span>
        <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>  
          <h5>Chat AI</h5>
          <p>
            <img
              src="https://img.icons8.com/?size=512w&id=78983&format=png&color=74E31D"
              width={20}
              height={20}
              alt=""
            />
            Online
          </p>
        </div>
      </div>
      <div className="chat">
        <div className="chatsContainer" ref={chatContainerRef}>
          {displayMessage && displayMessage.length > 0 ? (
            displayMessage.map((msg, index) => (
              <div
                key={index}
                className={
                  msg.sender === "user"
                    ? "messageContainer userContainer"
                    : "messageContainer aiContainer"
                }
              >
                {msg.sender === "ai" && (
                  <div className="avatarContainer">
                    <img src={IconsBot} alt="Avatar" className="avatar" />
                    <p className="botTextSize"></p>
                  </div>
                )}
                <div
                  className={
                    msg.sender === "user" ? "message user" : "message other"
                  }
                >
                  <ReactMarkdown remarkPlugins={[remarkBreaks]}>
                    {msg.message}
                  </ReactMarkdown>
                  <span>{msg.time}</span>
                </div>
                {msg.sender === "user" && (
                  <div className="avatarContainer">
                    <img
                      src={
                        "https://cdn-icons-png.flaticon.com/512/17655/17655721.png" ||
                        "https://cdn-icons-png.flaticon.com/512/17655/17655721.png"
                      }
                      alt="Avatar"
                      className="avatar"
                    />
                    <p className="avatarName">
                      {localStorage.getItem("userName") !== null
                        ? localStorage.getItem("userName")
                        : // localStorage.getItem("no-msisdn")
                          ""}
                    </p>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="emptyContainer">
              <div className="imageContainer">
                <img
                  src={IconsBot}
                  alt=""
                  className="emptyImg"
                />
                <h5>Welcome {localStorage.getItem("no-msisdn")}</h5>
                <p>Ask our AI-powered Chat AI anything about games!</p>
              </div>
              <div className="suggestion">
                <p className="heading">Suggestions on what to ask Our AI</p>
                <div className="suggestionQuestions">
                  {
                    arrayOfSuggestedQuestions.map((question, index) => (
                      <span key={index}
                    onClick={() =>
                      sendPrompt(question)
                    }
                    >
                    <p style={{ userSelect: "text" }}>
                      {question}
                    </p>
                  </span>
                    ))
                  }
                </div>
              </div>
            </div>
          )}

          {loading && (
            <div className="messageContainer aiContainer">
              <div className="avatarContainer">
                <img
                  src={IconsBot}
                  alt="Avatar"
                  className="avatar"
                />
                <p className="botTextSize"></p>
              </div>
              <div className="message other">
                <span style={{  fontSize: "16px", fontWeight: "bold", display: "flex", alignItems: "center", gap: "8px", paddingRight:"20px"}}>
                  Thinking   <span class="loaderForThinking"></span>
                </span>
              </div>
            </div>
          )}
        </div>
        <div className="inputContainer">
          <div className="inputWrapper">
            <input
              type="text"
              placeholder="Type your prompt here"
              onChange={getInputValue}
              value={textValue}
              name="prompt"
              disabled={loading}
            />
            <img
              src="   https://cdn-icons-png.flaticon.com/512/13411/13411210.png "
              alt="Send"
              className="sendMessage"
              onClick={loading ? null : () => sendPrompt(textValue)}
              style={{
                opacity: loading ? 0.5 : 1,
                cursor: loading ? "not-allowed" : "pointer",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
